// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedMenu: Object,
};

const DeleteMenu = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedMenu,
  } = props;

  const deleteMenus = () => {
    submit(selectedMenu.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteMenus} type="danger">Delete</SpButton>,
      ]}
      title="Delete Menu"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this Menu?</div>
        <SpH5 className="pb-3">
          <div>{selectedMenu.name}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteMenu;
